import EA from 'helpers/init';

// Add method to <img> element, add your img path to "data-src", leave empty src (src="")
export default EA.Methods.imageLazyLoad = ($this) => {
    const imageEl = $this;
    let observer;
    const offset = $this.dataset.offset || '1400';
    const offsetMultiplier = $this.dataset.offsetMultiplier || '200';
    const multiplier = $this.dataset.multiplier || '0';
    const timerOffset = $this.dataset.timerOffset || '175';

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                imageEl.src = imageEl.dataset.src;
                observer.disconnect();
            }
            // console.log(entry.isIntersecting);
        });
    }

    function createObserver() {
        const options = {
            root: null,
            scrollMargin: '700px',
            rootMargin: '700px',
            threshold: 0,
        };

        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(imageEl);
    }

    createObserver();
};

